<template>
  <footer class="app-footer">
    created by <a class="app-footer__link" href="https://kkmet.com" target="_blank" rel="noreferer noopener">kkmet</a> -
    <a class="app-footer__link" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=townfaker@gmail.com" target="_blank" rel="noreferer noopener">Contact</a> - <a class="app-footer__link" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=townfaker@gmail.com" target="_blank" rel="noreferer noopener">Report an issue</a>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
.app-footer {
  font-size: 13px;
  color: #888;
  text-align: center;
  padding: 8px 0;

  &__link {
    border-bottom: 1px dashed currentColor;
  }
}
</style>